export const HERO_SECTION_COPY = {
  mainHeadingLine1: 'Gousto menus and meal planning ideas to make your week easier',
  descriptionParagraph1:
    'Hungry for tasty meals without the faff? We’ve got you. With Gousto’s meal plan delivery service, you’ll get mouthwatering recipes and fresh ingredients delivered right to your door. Choose a Gousto meal plan today and say goodbye to dinner drama.',
  ctaButtonText: "Explore this week's menu",
}
